import { ProcessCard } from "@/components/screen/global-components/process/ProcessCards";

export const affiliateSupportCards: ProcessCard[] = [
  {
    id: 1,
    title: "Sign up",
    description:
      "Email our support team your name and business information to get started.",
  },
  {
    id: 2,
    title: "Promote Languex",
    description:
      "We’ll provide you with a unique tracking URL to capture the referrals you send our way. You’ll use this link to share on your content channels and social media.",
  },
  {
    id: 3,
    title: "Earn rewards",
    description:
      "Receive up to 25% commission for the sales you generate with no cap on the number of referrals. Monitor your success in referral reporting inside of our platform.",
  },
];

export const affiliateProcessData = {
  title: "How to join our affiliate translate program",
  description:
    "We provide real-time tracking of your performance and ensure monthly payouts through PayPal.",
  cards: affiliateSupportCards,
};
